import { useState, useRef } from "react";
import {
  createUserWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup
} from "firebase/auth";
import auth from "./firebase";
import { useNavigate } from "react-router-dom";
import "./Register.css";
import imgCover from "./0044.jpg";
import imgCharacter from "./aaa.png";

/* PROVEEDOR DE GOOGLE */
const googleProvider = new GoogleAuthProvider();

googleProvider.setCustomParameters({
  prompt: "select_account"
});

const Register = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    user: "",
    email: "",
    password: "",
    confirmPassword: ""
  });

  const [termsAccepted, setTermsAccepted] = useState(false);
  const [toast, setToast] = useState({
    show: false,
    message: ""
  });

  const cardRef = useRef(null);

  const showToast = (message) => {
    setToast({
      show: true,
      message
    });

    setTimeout(() => {
      setToast({
        show: false,
        message: ""
      });
    }, 3000);
  };

  const handleMouseMove = (e) => {
    if (cardRef.current) {
      const rect = cardRef.current.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      cardRef.current.style.setProperty("--x", `${x}px`);
      cardRef.current.style.setProperty("--y", `${y}px`);
    }
  };

  const handleChange = (e) => {
    const { id, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [id]: value
    }));
  };

  /* REGISTRO CON CORREO Y CONTRASEÑA */
  const handleSubmit = async (e) => {
    e.preventDefault();

    const {
      user,
      email,
      password,
      confirmPassword
    } = formData;

    if (user.length < 3) {
      showToast("Usuario demasiado corto");
      return;
    }

    if (password.length < 6) {
      showToast("La contraseña es muy corta");
      return;
    }

    if (password !== confirmPassword) {
      showToast("Las contraseñas no coinciden");
      return;
    }

    if (!termsAccepted) {
      showToast(
        "Debes confirmar que eres mayor de 18 años"
      );
      return;
    }

    try {
      await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );

      showToast("Cuenta creada correctamente");

      setTimeout(() => {
        navigate("/");
      }, 1000);
    } catch (error) {
      console.log(error);
      showToast(error.message);
    }
  };

  /* INICIO DE SESIÓN CON GOOGLE */
  const handleGoogleSignIn = async () => {
    if (!termsAccepted) {
      showToast(
        "Debes confirmar que eres mayor de 18 años"
      );
      return;
    }

    try {
      const result = await signInWithPopup(
        auth,
        googleProvider
      );

      const nombre =
        result.user.displayName ||
        result.user.email ||
        "usuario";

      showToast(`Bienvenido, ${nombre}`);

      setTimeout(() => {
        navigate("/");
      }, 1000);
    } catch (error) {
      console.error(error);

      if (error.code === "auth/popup-closed-by-user") {
        showToast("Cerraste la ventana de Google");
        return;
      }

      if (error.code === "auth/popup-blocked") {
        showToast(
          "El navegador bloqueó la ventana de Google"
        );
        return;
      }

      if (
        error.code ===
        "auth/account-exists-with-different-credential"
      ) {
        showToast(
          "Este correo ya está registrado con otro método"
        );
        return;
      }

      if (error.code === "auth/unauthorized-domain") {
        showToast(
          "Este dominio no está autorizado en Firebase"
        );
        return;
      }

      showToast(
        "No se pudo iniciar sesión con Google"
      );
    }
  };

  return (
    <div className="register-container">
      <div className="bg"></div>
      <div className="overlay"></div>
      <div className="glow"></div>

      <div className="wrapper">

        {/* REGISTRO IZQUIERDA */}
        <div
          className="card"
          ref={cardRef}
          onMouseMove={handleMouseMove}
        >
          <div className="top">
            <div className="logo">
              TMOXNight
            </div>

            <div className="sub">
              PREMIUM MEMBERSHIP · 18+
            </div>
          </div>

          <form onSubmit={handleSubmit}>

            <div className="group">
              <input
                type="text"
                className="input"
                id="user"
                placeholder=" "
                required
                value={formData.user}
                onChange={handleChange}
              />

              <label className="label">
                Usuario
              </label>
            </div>

            <div className="group">
              <input
                type="email"
                className="input"
                id="email"
                placeholder=" "
                required
                value={formData.email}
                onChange={handleChange}
              />

              <label className="label">
                Correo electrónico
              </label>
            </div>

            <div className="group">
              <input
                type="password"
                className="input"
                id="password"
                placeholder=" "
                required
                value={formData.password}
                onChange={handleChange}
              />

              <label className="label">
                Contraseña
              </label>
            </div>

            <div className="group">
              <input
                type="password"
                className="input"
                id="confirmPassword"
                placeholder=" "
                required
                value={formData.confirmPassword}
                onChange={handleChange}
              />

              <label className="label">
                Confirmar contraseña
              </label>
            </div>

            <div className="check">
              <input
                type="checkbox"
                id="terms"
                required
                checked={termsAccepted}
                onChange={(e) =>
                  setTermsAccepted(
                    e.target.checked
                  )
                }
              />

              <label htmlFor="terms">
                Confirmo que soy mayor de 18 años.
              </label>
            </div>

            <button
              className="btn"
              type="submit"
            >
              CONTINUAR
            </button>

            {/* SEPARADOR */}
            <div className="auth-divider">
              <span>O</span>
            </div>

            {/* BOTÓN DE GOOGLE */}
            <button
              type="button"
              className="btn google-btn"
              onClick={handleGoogleSignIn}
            >
              <span className="google-icon">
                G
              </span>

              CONTINUAR CON GOOGLE
            </button>

          </form>

          <div className="bottom">
            ¿Ya tienes cuenta?

            <a
              href="/login"
              onClick={(e) => {
                e.preventDefault();
                navigate("/login");
              }}
            >
              Iniciar sesión
            </a>
          </div>
        </div>

        {/* TARJETA 3D DERECHA */}
        <div className="card3d">
          <div className="wrapper3d">
            <img
              src={imgCover}
              className="cover-image"
              alt=""
            />
          </div>

          <img
            src={imgCharacter}
            className="character"
            alt=""
          />
        </div>
      </div>

      <div
        className={`toast ${
          toast.show ? "show" : ""
        }`}
      >
        {toast.message}
      </div>
    </div>
  );
};

export default Register;